import AuthService from './AuthService';
import { constants } from '../constant/constant';

let connection = null;
let retriesCount = 0;
let retrySchedule = null;
const buildHashInterval = null;
let callbackMethod = null;

const onClose = (e) => {
  if (AuthService.isLoggedIn()) {
    e.wasClean && console.log('Server Closed Websocket Connection');
  } else {
    console.log('Websocket Connection Closed');
  }
};

const onMessage = (message) => {
  callbackMethod && callbackMethod(message);
};

const SocketService = {
  close: () => {
    if (connection) {
      if (connection.close) {
        connection.close();
      } else {
        // For IE
        connection.websocket.close();
      }
    }
  },

  connect: (Callback = callbackMethod) => {
    callbackMethod = Callback;

    const { socketToken } = sessionStorage;
    if (socketToken) {
      // eslint-disable-next-line no-use-before-define
      _connect(socketToken);
    }
  },

  send: (data) => {
    if (connection) {
      if (connection.readyState === 1) {
        connection.send(typeof data === 'string' ? data : JSON.stringify(data));
      } else {
        // eslint-disable-next-line no-use-before-define
        retryConnect();
      }
    }
  },
};

const retryConnect = () => {
  clearInterval(buildHashInterval);
  if (retrySchedule) {
    console.log('Another retry is scheduled, Aborting Socket Connection!');
    return false;
  } if (!AuthService.isLoggedIn()) {
    console.log('User is not logged in, Aborting Sochet connection!');
  }
  if (retriesCount < 10) {
    retriesCount += 1;
  }
  connection = null;
  const retryAfter = retriesCount * 10;
  console.log('Socket connection will be retried after', retryAfter, 'seconds');

  retrySchedule = setTimeout(() => {
    console.log('Socket connection retrying now');
    clearTimeout(retrySchedule);
    retrySchedule = null;
    SocketService.connect();
  }, 5 * 1000);
};

const onError = () => {
  console.warn(`Failed establishing WebSocket connection with ${constants.SOCKET_URL}`);
  retryConnect();
};

const onOpen = () => {
  console.log(`WebSocket connection established with ${constants.SOCKET_URL}`);
  retriesCount = 0;
  setInterval(() => {
    SocketService.send('ping');
  }, 60000);
};

const _connect = (_socketToken) => {
  if (!constants.SOCKET_URL) {
    console.error('Please assign a SOCKET_URL in constants.');
    return;
  }
  const url = `${constants.SOCKET_URL}/${_socketToken}`;
  // const url = `${constants.SOCKET_URL}`;
  connection = new WebSocket(url);
  connection.onopen = onOpen.bind(this);
  connection.onerror = onError.bind(this);
  connection.onclose = onClose.bind(this);
  connection.onmessage = onMessage.bind(this);
};
export default SocketService;
